import { Navigate } from "react-router-dom";
import { useMe } from "./queries";

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { data: user, isPending, isError, error } = useMe();
  if (isPending) return <div className="p-8">Loading…</div>;
  // Truthy user wins even when a background refetch errored — the cached
  // session is still valid to render the shell against.
  if (user) return <>{children}</>;
  // A real /me failure (network, 5xx, schema mismatch). Surface it instead
  // of bouncing to /sign-in, which would mask the underlying issue and ask
  // the user to re-enter credentials they don't need to.
  if (isError) {
    return (
      <div className="p-8 space-y-2">
        <p className="text-sm">Couldn't load your session.</p>
        <p className="text-sm text-muted-foreground">{error?.message ?? "Unexpected error"}</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="text-sm underline"
        >
          Retry
        </button>
      </div>
    );
  }
  // user === null: getCurrentUser caught a 401 — really signed out.
  return <Navigate to="/sign-in" replace />;
}
